import { ActionsFile } from '@tock/shared/utils/connect';
import { ToastProps } from '@tock/toast/src/ToastActions';

export const displayRefundInSyncError = (
  toast: ActionsFile<{
    showError: (
      message: string | JSX.Element,
      options?: Pick<ToastProps, 'linkText' | 'onClickLink' | 'onClear'>
    ) => BaseTockAction;
  }>
): void => {
  toast.showError(
    'A previous edit on this booking is still in process. For further assistance, please contact Tock Support.',
    {
      linkText: 'Support',
      onClickLink: () => {
        window.open('https://www.exploretock.com/help');
      },
    }
  );
};
